import React from 'react';
import { IQuestionItem } from 'pages/formsCreate/types';
import { useState } from 'react';
import { useStyles } from './styles';
import { QuestionTypeIcon } from 'pages/formsCreate/CreatedQuestionsContainer/QuestionDragCard/QuestionTypeIcon';
import { RenderQuestion } from './RenderQuestion';
import { useAnswerContext } from 'pages/forms/context/AnswerProvider';

interface IProps {
  data: IQuestionItem;
  disableInput?: boolean;
}

export const QuestionCard = ({ data, disableInput }: IProps) => {
  const { card, cardMain, cardTitle } = useStyles();
  const { title, type } = data;

  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const handleClickOptions = () => {
    setIsOptionsOpen(!isOptionsOpen);
  };

  const { handleChangeAnswer } = useAnswerContext();

  return (
    <div className={card}>
      <div className={cardMain} onClick={handleClickOptions}>
        <div className={cardTitle}>
          <QuestionTypeIcon type={type} />
          {title}
        </div>
      </div>
      <RenderQuestion question={data} handleChangeAnswer={handleChangeAnswer} disableInput={disableInput} />
    </div>
  );
};
